import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import FilmagemFozPage from "./pages/FilmagemFozPage";
import CriacaoDeSitesPage from "./pages/CriacaoDeSitesPage";
import LandingPagesPage from "./pages/LandingPagesPage";
import GestaoPresencialPage from "./pages/GestaoPresencialPage";
import StudioLandingPage from "./pages/StudioLandingPage";
import ShortHomePage from "./pages/ShortHomePage";
import BrandHomePage from "./pages/BrandHomePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BrandHomePage />} />
        <Route path="/filmagem-foz-do-iguacu" element={<FilmagemFozPage />} />
        <Route path="/criacao-de-sites" element={<CriacaoDeSitesPage />} />
        <Route path="/landing-pages" element={<LandingPagesPage />} />
        <Route path="/gestao-presencial" element={<GestaoPresencialPage />} />
        {/* Hidden routes — not linked, not indexed */}
        <Route path="/studio" element={<StudioLandingPage />} />
        <Route path="/agencia" element={<HomePage />} />
        <Route path="/flyer" element={<ShortHomePage />} />
        <Route path="/novo" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
